import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=0a0ca1c0&scoped=true&"
import script from "./VFooter.vue?vue&type=script&lang=ts&"
export * from "./VFooter.vue?vue&type=script&lang=ts&"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=0a0ca1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ca1c0",
  null
  
)

export default component.exports